import {
  Button,
  Col,
  Modal,
  Radio,
  RadioChangeEvent,
  Row,
  Space,
  Switch,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import "./AssessmentTableStyles.scss";
import TextArea from "antd/lib/input/TextArea";
import debounce from "lodash/debounce";
import NoData from "components/UI/NoData/NoData";

const ratingOptions = [
  { label: "", value: "Low" },
  { label: "", value: "Medium" },
  { label: "", value: "High" },
];

const colors = {
  Experiences: "#990000CC",
  Traits: "#2E4A79E5",
  Drivers: "#008D8B",
};

interface ExperienceItem {
  title: string;
  level: string;
  comment: string;
}

interface PropsType {
  open: boolean;
  setOpen: any;
  view: string;
  setView: any;
  candidateAssessment: any;
  checkIfDataIsPresent: (type: string) => boolean;
}

const GetRow = ({
  rowData,
  index,
  view,
  TableData,
  setTableData,
}: {
  rowData: ExperienceItem;
  index: number;
  view: string;
  TableData: ExperienceItem[];
  setTableData: any;
}) => {
  const { title, level, comment } = rowData;
  return (
    <div className="assessment-row">
      <div className="title-input" style={{ background: colors[view] }}>
        <div
          className="textarea-styles title-center"
          style={{ background: colors[view] }}
        >
          {title}
        </div>
      </div>
      <div className="levels-input">
        <div
          className="level-box"
          style={{ background: level === "Low" ? "#bc9623cc" : colors[view] }}
        />
        <div
          className="level-box"
          style={{
            background: level === "Medium" ? "#bc9623cc" : colors[view],
          }}
        />
        <div
          className="level-box"
          style={{ background: level === "High" ? "#bc9623cc" : colors[view] }}
        />
      </div>
      <div className="definition-input" style={{ background: colors[view] }}>
        <div className="textarea-styles" style={{ background: colors[view] }}>
          {comment}
        </div>
      </div>
    </div>
  );
};

const AssessmentTableModal: React.FC<PropsType> = ({
  open,
  setOpen,
  view,
  candidateAssessment,
  setView,
  checkIfDataIsPresent,
}) => {
  // const [confirmLoading, setConfirmLoading] = useState(false);
  const [TableData, setTableData] = useState([]);

  useEffect(() => {
    if (view === "Experiences") {
      setTableData(candidateAssessment.experience);
    } else if (view === "Traits") {
      setTableData(candidateAssessment.traits);
    } else {
      setTableData(candidateAssessment.drivers);
    }
  }, [view]);

  // const handleOk = () => {
  //   setConfirmLoading(true);
  //   setTimeout(() => {
  //     setOpen(false);
  //     setConfirmLoading(false);
  //   }, 2000);
  // };

  const handleCancel = () => {
    setOpen(false);
  };

  // const hideAssessment = (checked: boolean) => {
  //   console.log(`switch to ${checked}`);
  // };

  const switchView = (toView: string) => {
    setView(toView);
  };

  const viewButtonsvisible = () => {
    let show = 3;
    if (candidateAssessment?.hideExperience === true) --show;
    if (candidateAssessment?.hideTraits === true) --show;
    if (candidateAssessment?.hideDrivers === true) --show;

    if (show < 2) {
      return false;
    } else return true;
  };

  return (
    <>
      <Modal
        width={1109}
        title={<span style={{ fontSize: "18px" }}>Assessment table</span>}
        centered
        open={open}
        onCancel={handleCancel}
        footer={null}
      >
        <Row className="view-switches">
          {!candidateAssessment?.hideExperience &&
            checkIfDataIsPresent("experience") && (
              <Button
                className={view === "Experiences" ? "Experience" : ""}
                onClick={() => switchView("Experiences")}
              >
                Experiences
              </Button>
            )}
          {!candidateAssessment?.hideTraits &&
            checkIfDataIsPresent("traits") && (
              <Button
                className={view === "Traits" ? "Traits" : ""}
                onClick={() => switchView("Traits")}
              >
                Traits
              </Button>
            )}
          {!candidateAssessment?.hideDrivers &&
            checkIfDataIsPresent("drivers") && (
              <Button
                className={view === "Drivers" ? "Drivers" : ""}
                onClick={() => switchView("Drivers")}
              >
                Drivers
              </Button>
            )}
        </Row>
        <div
          className="assessment-table-headings"
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "12px",
            marginLeft: "2px",
          }}
        >
          <div
            style={{
              width: "180px",
              fontWeight: 600,
              fontSize: "14px",
              color: "#495057",
            }}
          ></div>
          <div
            style={{
              width: "75px",
              fontSize: "14px",
              color: "#495057",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            Low
          </div>
          <div
            style={{
              width: "75px",
              fontSize: "14px",
              color: "#495057",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            Medium
          </div>
          <div
            style={{
              width: "75px",
              fontSize: "14px",
              color: "#495057",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            High
          </div>
          <div
            style={{
              width: "630px",
              fontSize: "14px",
              color: "#495057",
              fontWeight: 500,
            }}
          >
            Comments
          </div>
        </div>
        <div style={{ width: "100%" }}>
          {TableData?.length > 0 ? (
            TableData?.map((row, index) => (
              <GetRow
                key={index}
                rowData={row}
                index={index}
                view={view}
                TableData={TableData}
                setTableData={setTableData}
              />
            ))
          ) : (
            <NoData message={`No required ${view} added`} />
          )}
        </div>
      </Modal>
    </>
  );
};

export default AssessmentTableModal;
